



import { Add } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import AddEmpolyeess from './AddEmpolyeess';
import AddMoney from './AddMoney';
import WalletsReports from './WalletsReports';
import Usage from './Usage';

const AddWalletEmpolyee = () => {
  const [activeTab, setActiveTab] = useState('Add Employee');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const tabContent = {
    "Add Employee": <AddEmpolyeess />,
    "Add Money": <AddMoney />,
    "Reports": <WalletsReports />,
     "Usage": <Usage />,
  };

  return (
    <div className="container-fluid">
      <div className="Row">
        <div className="col-lg-2"></div>

        <div className="Col-lg-7">
          <div className="left-column">
            <div className="tabs-wrapperpayment">

              {/* ===== TAB BUTTONS ===== */}
              <div
                className="overviewbuttonsyy"
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row", // ✅ mobile column
                  justifyContent: "center",
                  alignItems: "center",
                  gap: isMobile ? "10px" : "14px",
                  marginTop:isMobile ? "3px":"3px",
                   marginBottom:isMobile ? "20px":"",
                }}
              >
                {Object.keys(tabContent).map((label) => {
                  const isActive = activeTab === label;

                  return (
                    <button
                      key={label}
                      onClick={() => setActiveTab(label)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        padding: isMobile ? "8px 16px" : "12px 28px", // ✅ small on mobile
                        borderRadius: "12px",
                        border: isActive
                          ? "2px solid #ee6521"
                          : "1px solid #ddd",
                        background: isActive
                          ? "linear-gradient(135deg,#ee6521,#ee6521)"
                          : "#fff",
                        color: isActive ? "#fff" : "#444",
                        fontWeight: isActive ? "600" : "500",
                        fontSize: isMobile ? "13px" : "15px", // ✅ small text
                        cursor: "pointer",
                        width: isMobile ? "100%" : "160px", // ✅ full width column
                        maxWidth: isMobile ? "260px" : "160px",
                        transition: "0.3s",
                      }}
                    >
                      {label === "Add Employee"}
                      {label === "Add Money" }
                      {label === "Reports" }
                      {label}
                    </button>
                  );
                })}
              </div>

              {/* ===== TAB CONTENT ===== */}
              <div
                className="tab-content"
                style={{
                  overflow: 'auto',
                  height: isMobile ? '700px' : '520px',
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  maxWidth: '944px',
                }}
              >
                {tabContent[activeTab]}
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddWalletEmpolyee;


